import { FindResultWithMeta, ModelDef } from './ModelDef'

/**
 * src/server/AnotherDataSourcesHandler へ登録した dataSourceName をデータソース元とするためのModel
 * find / bulkUpsert / bulkDelete を /core/anotherDatasource* API へ配線する
 * （サーバ側で enableWrite でない場合はエラー）
 *
 * 書込の beforeSave / afterSave は storeMethods 側で override の前後に実行される
 */
export const anotherDataSourceFrontModelDefFactory = <
  ModelDataType = Record<string, any>,
>(
  {
    modelDef,
    dataSourceName,
  }: {
    modelDef: ModelDef<ModelDataType>
    dataSourceName: string
  },
  readonly = true,
): ModelDef<ModelDataType> => {
  const find = async (query): Promise<FindResultWithMeta<ModelDataType>> => {
    // @ts-ignore
    return $core.$d.transport.post('/core/anotherDatasourceFind', {
      ...query,
      dataSourceName,
    })
  }

  const bulkUpsert = async (args) => {
    // @ts-ignore
    return $core.$d.transport.post('/core/anotherDatasourceBulkUpsert', {
      ...args,
      dataSourceName,
      modelName: args.modelName || args.collectionName || modelDef.tableName,
    })
  }

  const bulkDelete = async (args) => {
    // @ts-ignore
    return $core.$d.transport.post('/core/anotherDatasourceBulkDelete', {
      ...args,
      dataSourceName,
      modelName: args.modelName || args.collectionName || modelDef.tableName,
      docIds: args.docIds,
    })
  }

  // デフォルト配線の後に既存 overrides をマージ（呼び出し側指定を優先）
  modelDef.overrides = {
    find,
    findById: async (id) => {
      return (await find({ filter: { id: { _eq: id } } })).data?.[0] || null
    },
    bulkUpsert,
    bulkDelete,
    ...(modelDef.overrides || {}),
  }

  modelDef.doNotSyncModel = true
  if (readonly) {
    modelDef.creatable = false
    modelDef.updatable = false
    modelDef.deletable = false
  }
  return modelDef
}
